export default __webpack_public_path__ + "static/media/clock.da73bd21.svg";